import { Service } from '../Service';
import { TiffBatch } from '../../model/tiffing/TiffBatch';

import IAngularEvent = angular.IAngularEvent;

export class TiffBatchService extends Service<any> {
  constructor(resource: any, rootScope: IRootScope, resourceWrapperService) {
    super({resource, rootScope, resourceWrapperService});

    this.RegisterUpdateEventListener("FeedService.TiffBatchUpdate", async (e: IAngularEvent, message) => new TiffBatch(message.id, message.projectId, message.name, message.percentageComplete));

    this.RegisterCompleteEventListener("FeedService.TiffBatchComplete", async (e: IAngularEvent, message) => new TiffBatch(message.id, "", "", 100));
  }
}

frontendApp.factory("TiffBatchService", ['$resource', '$rootScope', 'ResourceWrapperService', function(resource, rootScope, resourceWrapperService) {
  return new TiffBatchService(resource, rootScope, resourceWrapperService);
}]);
